import { render, staticRenderFns } from "./DepositDetail.vue?vue&type=template&id=43ceede6&"
import script from "./DepositDetail.vue?vue&type=script&lang=js&"
export * from "./DepositDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports